import { render } from "./CadastroCliente.vue?vue&type=template&id=2a51ec6c"
import script from "./CadastroCliente.vue?vue&type=script&lang=ts"
export * from "./CadastroCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script